module.exports = __webpack_public_path__ + "static/media/employerbanner.a0f9d419.png";